import ColorTheme from '@/features/color-theme/models/ColorTheme';

export default function getSystemColorTheme() {
  const hasDarkPreference = matchMedia('(prefers-color-scheme: dark)').matches;
  return hasDarkPreference ? ColorTheme.DARK : ColorTheme.LIGHT;
}
